import { AxiosPromise } from 'axios';

import { ISearch } from '~/components/Pagination/Search';
import { IPagination } from '~/models/Common';
import { IMethod } from '~/models/Method';

import api from './api';

const MethodService = {
  // getAllMethods(data: ISearch): AxiosPromise<IPagination<IMethod[]>> {
  getAllMethods(data: ISearch): AxiosPromise<IMethod[]> {
    // return api.get('/power-creators/all/admins', { params: data });
    return api.get('power-creators/all/admins');
  },

  getOneMethod(methodId: string): AxiosPromise<IMethod> {
    return api.get(`power-creators/${methodId}`);
  },

  editMethod(methodId: string, data: IMethod): AxiosPromise {
    return api.put(`power-creators/${methodId}`, data);
  },

  createMethod(data: IMethod): AxiosPromise {
    return api.post(`power-creators`, data);
  },

  deleteMethod(methodId: string): AxiosPromise {
    return api.delete(`power-creators/${methodId}`);
  },
};

export default MethodService;
